function AlarmRules2() {
    /// <summary>
    /// This object provides common functions for the Widget.Events.alarmRules2. <br/>
    /// Author: ARF<br />
    /// Date: 24.7.2019<br />
    /// Copyright ©: EUDT GmbH 2019 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 22.10.2019                                              *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.chartHeight = 0;
    this.logicCounter = -1;
    this.defaultDifferentialTime = 1;
    this.defaultIntegralTime = 1;
    this.defaultPT1Time = 5;
    this.defaultDT1Time = '1/3';
    this.defaultIntervalLimit = 1;
    this.bNewAlarm = false;


}
AlarmRules2.prototype = new vcTemplate();

AlarmRules2.prototype.init = function () {
    /// <summary>
    /// This function inits all checkbox event handlers, radio buttons, datepickers and buttons.
    /// </summary>
    var me = this;
    var fl;
    try {
        if (me.error) { return false; }
        me.showInfo("", "", false);

        me.chartHeight = parseInt(me.height - me.visual.find("#div-save").height() -35 );
        me.visual.find("#div-logic").height(me.chartHeight);

       
        if (me.eventType !== 4) {
            me.visual.find(".coll").addClass("vc-grid-8col");
        } else {
            me.visual.find(".coll").addClass("vc-grid-7col");
        }

        //parse the function list
        fl = JSON.parse(me.functList);


        if (fl.Bluid > -1) {
            me.visual.find("#ddl-bluid").val(fl.Bluid);
            //me.visual.find(".task").show();
            me.bNewAlarm = false;
        } else {
         //   me.visual.find(".task").hide();
            me.bNewAlarm = true;
        }
        //set the proper signals for the selected unit
        me.setUnitSignals();
        me.visual.find("#ddl-bluid").off("change").on("change", function () { me.setUnitSignals(); });

        //build the conditions, digital signals and calendar
        me.generateConditions(fl);
       // me.generateDigitalList(fl);
        //  me.initCalendarFilter();


        if (me.eventType !== 4) {
            me.visual.find(".signals-target").hide();
        }

     
        me.visual.find("#ddl-interval").val(me.interval);
        me.visual.find("#ddl-data-type").val(me.datatype);

        me.visual.find("#ddl-data-type").off("change").on("change", function () { me.handleDataType() });
        me.visual.find(".signals").off("change").on("change", function() {
            me.validateSignalInterval();
            me.handleDataType();
        });
        me.visual.find("#ddl-interval").off("change").on("change",
            function() {
                me.visual.find(".current-dims").html("[" + me.visual.find("#ddl-interval").val() + " min]");

            });
        me.visual.find(".current-dims").html("[" + me.visual.find("#ddl-interval").val() + " min]");

        me.handleDataType();

        me.validateDDLs();
      
        me.visual.find('#div-logic ').on("keyup", ".box .validate", function () { me.validate($(this));});

        // me.visual.find('#divBtnRefresh').off('click').on("click",function () { me.showChart(true);});
        me.visual.find('#divBtnSave').off('click').on("click", function () { me.save(); });
        me.visual.find('#divBtnSave').removeClass("active");

        //me.visual.find('.task').off('click').on("click", function () { me.askTask($(this)); });

       
        me.visual.off("change", ".ddl").on("change",".ddl",
            function() {
                me.validateDDLs();
                me.visual.find('#divBtnSave').removeClass("active").addClass("active");
            });

        me.visual.find("#ul-digital input").off("click").on("click",
            function () {me.visual.find('#divBtnSave').removeClass("active").addClass("active");});

        //switch between digital signals and calendar
        me.visual.find('#div-sub-menu .button-toggle').off("click").on("click", function() {

            me.visual.find('#div-sub-menu .button-toggle').removeClass("button-toggle-active");
            $(this).addClass("button-toggle-active");
            me.visual.find('#div-list-digital, #div-calendar-filter').hide();
            me.visual.find('#div-' + $(this).data("type")).show();
        }).button();

        //handler for add and delete condition
        me.visual.find('.coll').off("click", ".line.icons .caption").on("click", ".line.icons .caption", function(e) {
            me.visual.find('#divBtnSave').removeClass("active").addClass("active");
            if ($(this).attr("id") === "div-btn-add") {
                me.logicCounter ++;
                me.addLogic(fl.List[0]);
                me.validateDDLs();
               e.stopPropagation();
            }
            if ($(this).attr("id") === "div-btn-delete") {
              
                me.visual.find($(this)).parents(".condition").remove();
                me.logicCounter--;
              
                me.visual.find("#div-logic-" + me.logicCounter + " .icon-box").show();

            }
        });

      // me.showChart(true);

        return true;
    } catch (ex) { me.writeError('init', ex); return false; }
};


AlarmRules2.prototype.generateConditions = function (fl) {
    /// <summary>
    /// This function iterates all conditions and generates the list and logic.
    /// </summary>
    var me = this;
    var i;
    var logic = 1;
    try {
        if (me.error) { return false; }
      

        for (i = 0; i < fl.List.length; i++) {
            me.logicCounter++;
            me.addLogic(fl.List[i]);
            if (i === 0) {
                me.visual.find("#div-logic fieldset.logic #ddl-logic").hide();
                me.visual.find("#div-logic #div-btn-delete").hide();
                me.visual.find("#div-logic #ddl-logic").hide();
            }
        }

        for (i = 0; i < fl.Logic.length; i++) {
            if (fl.Logic[i] === "AND" || fl.Logic[i] === "OR" || fl.Logic[i] === "NAND" || fl.Logic[i] === "NOR") {
                me.visual.find("#div-logic #div-logic-" + logic + " #ddl-logic").val(fl.Logic[i]);
                logic++;
            }
        }

        return true;
    } catch (ex) { me.writeError('generateConditions', ex); return false; }
};




AlarmRules2.prototype.addLogic = function (funct) {
    /// <summary>
    /// This function adds one single condition.<br/>
    /// It clones the condition template and sets the values.
    /// </summary>
    var me = this;
    var index = 0;
    var condition;
    var tpl;
    try {

        index = me.logicCounter;

        tpl = me.visual.find("#div-logic-template").clone();
        tpl.attr("id", "div-logic-" + index);
        tpl.addClass("condition");

        me.visual.find("#div-logic .icon-box").hide();
        me.visual.find("#div-logic").append(tpl);

        condition = me.visual.find("#div-logic-" + index);
        condition.find("fieldset.logic .caption").html(me.resources.condition + " " + (index + 1));

        if (funct.Bsaid > -1) {
            condition.find("#ddl-signal").val(funct.Bsaid);
        }
        if (funct.BsaidAlarm > -1) {
            condition.find("#ddl-signal-alarm").val(funct.BsaidAlarm);
        }
        if (funct.BsaidTarget > -1) {
            condition.find("#ddl-signal-target").val(funct.BsaidTarget);
        }

        condition.find("#txt-mkorr").val((funct.MKorr + '').replace(".", ","));
        condition.find("#txt-skorr").val((funct.SKorr + '').replace(".", ","));

        condition.find("#ddl-funct-type").val(funct.FunctType);


        condition.find("#txt-min").val((funct.Minimum + '').replace(".", ","));
        condition.find("#txt-max").val((funct.Maximum + '').replace(".", ","));

        if (typeof (funct.StartDelay) !== "undefined") {
            condition.find("#txt-start-delay").val(funct.StartDelay);
        } else {
            condition.find("#txt-start-delay").val(0);
        }
        if (typeof (funct.EndDelay) !== "undefined") {
            condition.find("#txt-end-delay").val(funct.EndDelay);
        } else {
            condition.find("#txt-end-delay").val(0);
        }

        condition.find("#txt-differential-time").val(me.defaultDifferentialTime);
        condition.find("#txt-integral-time").val(me.defaultIntegralTime);
        condition.find("#txt-pt1-time").val(me.defaultPT1Time);
        condition.find("#txt-dt1-time").val(me.defaultDT1Time);
        condition.find("#txt-interval-limit").val(me.defaultIntervalLimit);

        condition.find("#div-mkorr").show();
        condition.find("#div-skorr").show();
        condition.find("#div-min").show();
        condition.find(".turns").hide();
        condition.find("#emax-dims").hide();


        if (funct.Attributes.length > 0) {
            switch (funct.FunctType) {
                //case 1:   break;
            case 2:
                condition.find("#txt-differential-time").val(funct.Attributes[0]);
            break;
            case 3:
                condition.find("#txt-integral-time").val(funct.Attributes[0]);
            break;
            case 4:
                    condition.find("#txt-pt1-time").val((funct.Attributes[0] + '').replace(".", ","));
            case 5:
                    var val = funct.Attributes[0];
                    var t1 = val % 1000;
                    var td = (val - t1) / 1000;
                
                    condition.find("#txt-dt1-time").val((td + '/' + t1));
          
                    break;
                case 6:
                    condition.find("#txt-interval-limit").val((funct.Attributes[0] + '').replace(".", ","));
                    break;
                case 7: //emax peak
                    condition.find("#div-mkorr").hide();
                    condition.find("#div-skorr").hide();
                    condition.find("#div-min").hide();
                    condition.find(".turns").show();
                    condition.find("#txt-interval-limit7").val((funct.Attributes[0] + '').replace(".", ","));

                    if (funct.Attributes.length > 1) {
                        condition.find("#txt-turn-on").val((funct.Attributes[1] + '').replace(".", ","));
                        condition.find("#txt-straight-off").val((funct.Attributes[2] + '').replace(".", ","));
                    } else {
                        condition.find("#txt-turn-on").val(100);
                        condition.find("#txt-straight-off").val(100);
                    }
                  
                    break;
                case 8: //emax 1 min
                    condition.find("#div-mkorr").hide();
                    condition.find("#div-skorr").hide();
                    condition.find("#div-min").hide();
                    condition.find(".turns").show();
                    condition.find("#emax-dims").show();
                    condition.find("#txt-interval-limit8").val((funct.Attributes[0] + '').replace(".", ","));
                    if (funct.Attributes.length > 1) {
                        condition.find("#txt-turn-on").val((funct.Attributes[1] + '').replace(".", ","));
                        condition.find("#txt-straight-off").val((funct.Attributes[2] + '').replace(".", ","));
                    } else {
                        condition.find("#txt-turn-on").val(100);
                        condition.find("#txt-straight-off").val(100);
                    }
                    break;
                case 9: //emax 15 min
                    condition.find("#div-mkorr").hide();
                    condition.find("#div-skorr").hide();
                    condition.find("#div-min").hide();
                    condition.find(".turns").show();
                    condition.find("#emax-dims").show();
                    condition.find("#txt-interval-limit9").val((funct.Attributes[0] + '').replace(".", ","));
                    if (funct.Attributes.length > 1) {
                        condition.find("#txt-turn-on").val((funct.Attributes[1] + '').replace(".", ","));
                        condition.find("#txt-straight-off").val((funct.Attributes[2] + '').replace(".", ","));
                    } else {
                        condition.find("#txt-turn-on").val(100);
                        condition.find("#txt-straight-off").val(100);
                    }
                break;
        }
    }

    condition.find("#ddl-funct-type").off("change").on("change", function () { me.toggleFunctTypes(condition) });
    me.toggleFunctTypes(condition);

        

     
        return true;
    } catch (ex) { me.writeError('addLogic', ex); return false; }
};




AlarmRules2.prototype.handleDataType = function () {
    /// <summary>
    /// This function switches between data interval types. 
    /// </summary>
    var me = this;
    var datatype;
    try {

        datatype = parseInt(me.visual.find("#ddl-data-type").val());
        if (datatype === 1) {
            me.visual.find("#ddl-interval, #lbl-interval").prop("disabled", true);
            var firstSignalInterval = me.visual.find("#div-logic-0 #ddl-signal option:selected").data("len");
            if (typeof (firstSignalInterval) !== "undefined") {
                me.visual.find("#ddl-interval").val(parseInt(firstSignalInterval / 60));
                me.visual.find(".current-dims").html("[" + me.visual.find("#ddl-interval").val() + " min]");
            }
           

        } else {
            me.visual.find("#ddl-interval, #lbl-interval").prop("disabled", false);
            me.visual.find(".current-dims").html("[" + me.visual.find("#ddl-interval").val() + " min]");
        }
       
        return true;
    } catch (ex) { me.writeError('handleDataType', ex); return false; }
};


AlarmRules2.prototype.toggleFunctTypes = function (condition) {
    /// <summary>
    /// This function switches between funcTypes. 
    /// </summary>
    var me = this;
    var obj;
    try {
       
        obj = condition.find("#ddl-funct-type");
        condition.find(".funct-type").hide();
        condition.find(".funct-type[data-id=" + parseInt(obj.val()) + "]").show();
     
        return true;
    } catch (ex) { me.writeError('toggleFunctTypes', ex); return false; }
};



AlarmRules2.prototype.setUnitSignals = function () {
    /// <summary>
    /// This function shows/hides signals based on the selected unit.
    /// </summary>
    var me = this;
    var bluid;
    try {
        if (me.error) { return false; }

        bluid = parseInt(me.visual.find("#ddl-bluid").val());
     
        me.visual.find("#ddl-signal option").hide();
       
        me.visual.find("#ddl-signal option[data-bluid='" + bluid + "']").show();
        me.visual.find("#ddl-signal option[data-bluid='-1']").show();
        me.visual.find("#ddl-signal option[data-bluid='-1']").prop("selected", true).change();

        me.validateDDLs();

        me.visual.find("#ul-digital li").hide();
        me.visual.find("#ul-digital li[data-bluid='" + bluid + "']").show();
        me.visual.find("#ul-digital li input").prop("checked", false);

        return true;
    } catch (ex) { me.writeError('setUnitSignals', ex); return false; }
};



AlarmRules2.prototype.save = function () {
  var me = this;
  try {

      var param = { "type":1 };
      param.AlarmSignalParam = me.getParameter();
     
      if (param.AlarmSignalParam === null) {return false};
     


   window.VisualCoreService.updateData(me.vcvid,me.vcgid, getCurrentTimestamp(), 0,0,'','',me.deviceType,me.langid , JSON.stringify(param),
     function (result) {
         if (result == null) { alert(me.resources.err_saveData);return false; }
        if (result === false) {
            alert(me.resources.err_saveData); 
        } else {
            _VCMQ.produce(me.visual, me.vcgid, 'EVENT_CONFIG_DIRTY', "");
            me.bNewAlarm = false;
           // me.visual.find(".task").removeClass("active").addClass("active").show();
         me.visual.find('#divBtnSave').removeClass("active");

            //showModalPopup("<div style='border-bottom:1px solid #ddd;margin-bottom:18px;font-weight:bold'>" + me.resources.sendConfigToLogger +"</div ><div id='divConfigUpdate" + me.vcgid + "'></div >", 640, 360);
            //me.vcVisual.addVisualBaseByName('div', "VISUAL_UNIT_CONFIGCOMMIT", "ConfigUpdate" + me.vcgid, getCurrentTimestamp(), 310, 600, '', '', 1);
        }
       return false; 
          });
      return true;
  } catch (ex) { me.writeError('save', ex); return false;}
};  




//validates the input fields and deactivates the save and preview button if the input values are invalid
AlarmRules2.prototype.validate = function (obj) {
    /// <summary>
    /// This function validates the input for one single input field.
    /// </summary>
    var me = this;
    var val;
    var vals;
    var bValid;
  try {

      val = obj.val().trim();

      if (val.length === 0 || val.indexOf(".") > -1) {
          obj.removeClass('txtEnabled');
          obj.removeClass('invalid').addClass('invalid');

      } else {
          if (obj.attr("id") !== "txt-dt1-time") {


              if ((validateNumeric(val) === false || isNaN(parseFloat(val)))) {

                  obj.removeClass('txtEnabled');
                  obj.removeClass('invalid').addClass('invalid');

              } else {
                  obj.removeClass('invalid');
                  obj.removeClass('txtEnabled').addClass('txtEnabled');
              }
          } else {
          
             //handle the specific dtt1-membered validation separately
              vals = val.split("/");
              
              if (vals.length === 2) {
                  bValid = !(vals[0].length === 0 || vals[1].length === 0);
                  if (bValid) {
                      bValid = !((validateNumeric(vals[0]) === false ||
                          validateNumeric(vals[1]) === false ||
                          isNaN(parseInt(vals[0])) || isNaN(parseInt(vals[1])) ));
                   
                  }
                  if (bValid) {
                      bValid = !(parseInt(vals[0]) < 1 || parseInt(vals[1])<0);
                  }

              } else {
                  bValid = false;
          
              }
            if (!bValid) {
                obj.removeClass('txtEnabled');
                obj.removeClass('invalid').addClass('invalid');
            } else {
                obj.removeClass('invalid');
                obj.removeClass('txtEnabled').addClass('txtEnabled');
            }


          }
      }
      me.validateSignalInterval();
      me.setSaveButton();

     
      return true;
  } catch (ex) { me.writeError('validate', ex); return false;}
};  




//validates the input fields and deactivates the save and preview button if the input values are invalid
AlarmRules2.prototype.validateDDLs = function () {
    /// <summary>
    /// This function validates all dropdown fields.
    /// </summary>
    var me = this;

    try {

        me.visual.find(".ddl:visible").not(".signals-alarm, .signals-target").each(function() {
            if ($(this).val() === '-1' || $(this).val() === null) {
                $(this).removeClass("invalid").addClass("invalid");
            } else {
                $(this).removeClass("invalid");
            }

        });
        me.validateSignalInterval();
        me.setSaveButton();


        return true;
    } catch (ex) { me.writeError('validateDDLs', ex); return false; }
};



//validates the input fields and deactivates the save and preview button if the input values are invalid
AlarmRules2.prototype.validateSignalInterval = function () {
    /// <summary>
    /// This function validates all dropdown fields.
    /// </summary>
    var me = this;
    var interval;
    try {
        interval = me.visual.find("#div-logic-0 .signals option:selected").data("len");
        if (typeof (interval) !== "undefined") {
          
            me.visual.find("#div-logic .signals").each(function () {
               
                if ($(this).find("option:selected").data("len") !== interval) {
                    $(this).removeClass("invalid, wrongInterval").addClass("invalid wrongInterval");
                 
                } else {
                    $(this).removeClass("invalid wrongInterval");
                }

            });

            me.setSaveButton();
        }

        return true;
    } catch (ex) { me.writeError('validateSignalInterval', ex); return false; }
};



AlarmRules2.prototype.setSaveButton = function () {
    /// <summary>
    /// This function sets the current save info state.
    /// </summary>
    var me = this;
    var sText;
    try {

        if (me.visual.find('.invalid').length === 0) {
            me.visual.find('#divBtnSave,#divBtnRefresh').addClass('active');
            me.visual.find('#div-save').removeClass("error");
            me.visual.find('#div-save-error').hide();

            //if (!me.bNewAlarm) {
            //    me.visual.find(".task").show();
            //}

        } else {
           // me.visual.find(".task").hide();
            me.visual.find('#divBtnSave,#divBtnRefresh').removeClass('active');
            me.visual.find('#div-save').addClass("error");

            if (me.visual.find('.wrongInterval').length === 0) {
                sText = me.resources.wrongInput;
            } else {
                sText = me.resources.wrongSignalInterval;
            }


            me.visual.find('#div-save-error').html(sText).show();
        }




        return true;
    } catch (ex) { me.writeError('setSaveButton', ex); return false; }
};




//simple function which inits a parameter object
AlarmRules2.prototype.getParameter = function () {
    /// <summary>
    /// This function generates the basic alarm properties
    /// </summary>
    var me = this;
    var param;
   
try {
    
    param = {};
    param.AlarmID = me.aid;

    param.FunctParameter = JSON.stringify(me.getFunctList());
    param.DataInterval = me.visual.find('#ddl-interval').val();

    if (param.DataInterval === null) {
     
        param.DataInterval = 1;
    } else {
        param.DataInterval = parseInt(param.DataInterval);
    }

    param.DataType = parseInt(me.visual.find('#ddl-data-type').val());
    param.Interval = "15M";
    param.Bsaid = -1;


  return param;
 } catch (ex) { me.writeError('getParameter', ex);return null;}
}; 


AlarmRules2.prototype.getFunctList = function () {
    /// <summary>
    /// This function generates the specific condition parameters
    /// </summary>
    var me = this;
    var cond = 0;
    var functList = {}

    var condition;
    try {

        functList.List = [];

        me.visual.find(".condition").each(function() {
            var p = {};
            condition = $(this);
            
            p.FunctType = parseInt(condition.find('#ddl-funct-type').val());

            p.Bsaid = parseInt(condition.find('#ddl-signal').val(), 10);
            p.BsaidAlarm = parseInt(condition.find('#ddl-signal-alarm').val(), 10);
            p.BsaidTarget = parseInt(condition.find('#ddl-signal-target').val(), 10);

            p.Minimum = condition.find('#txt-min').val();
            p.Minimum = parseFloat(p.Minimum.replace(/\./g, '').replace(',', '.'));

            p.Maximum = condition.find('#txt-max').val();
            p.Maximum = parseFloat(p.Maximum.replace(/\./g, '').replace(',', '.'));

            p.StartDelay = condition.find('#txt-start-delay').val();
            p.StartDelay = parseInt(p.StartDelay.replace(/\./g, '').replace(',', '.'));

            p.EndDelay = condition.find('#txt-end-delay').val();
            p.EndDelay = parseInt(p.EndDelay.replace(/\./g, '').replace(',', '.'));

            p.MKorr = condition.find('#txt-mkorr').val();
            p.MKorr = parseFloat(p.MKorr.replace(/\./g, '').replace(',', '.'));

            p.SKorr = condition.find('#txt-skorr').val();
            p.SKorr = parseFloat(p.SKorr.replace(/\./g, '').replace(',', '.'));

            p.Attributes = [];
            //  console.info(p.FunctType);
            switch (p.FunctType) {
            case 1:

                break;
            case 2:
                p.Attributes.push(parseInt(condition.find("#txt-differential-time").val()));
                break;
            case 3:
                    p.Attributes.push(parseInt(condition.find("#txt-integral-time").val()));
                break;
            case 4:
                p.Attributes.push(parseFloat(condition.find("#txt-pt1-time").val().replace(",", ".")));
                    break;
                case 5:
                    var vals = condition.find("#txt-dt1-time").val().split("/");
                p.Attributes.push(parseFloat(vals[0]) * 1000 + parseFloat(vals[1]));
                    break;
                case 6:
                    p.Attributes.push(parseFloat(condition.find("#txt-interval-limit").val().replace(",", ".")));
                    p.Attributes.push(parseFloat(condition.find("#txt-turn-on").val().replace(",", ".")));
                    p.Attributes.push(parseFloat(condition.find("#txt-straight-off").val().replace(",", ".")));
                    break;
                case 7:
                  
                    p.Attributes.push(parseFloat(condition.find("#txt-interval-limit7").val().replace(",", ".")));
                    p.Attributes.push(parseFloat(condition.find("#txt-turn-on").val().replace(",", ".")));
                    p.Attributes.push(parseFloat(condition.find("#txt-straight-off").val().replace(",", ".")));
                    break;
            case 8:
                    
                    p.Attributes.push(parseFloat(condition.find("#txt-interval-limit8").val().replace(",", ".")));
                    p.Attributes.push(parseFloat(condition.find("#txt-turn-on").val().replace(",", ".")));
                    p.Attributes.push(parseFloat(condition.find("#txt-straight-off").val().replace(",", ".")));
                    break;
            case 9:

                    p.Attributes.push(parseFloat(condition.find("#txt-interval-limit9").val().replace(",", ".")));
                    p.Attributes.push(parseFloat(condition.find("#txt-turn-on").val().replace(",", ".")));
                    p.Attributes.push(parseFloat(condition.find("#txt-straight-off").val().replace(",", ".")));
                break;
            default:
            }    
            functList.List.push(p);
        });
     
        functList.DigitalList = JSON.parse(me.functList).DigitalList;

        //me.visual.find("#ul-digital input:checked").each(function () {
        //    functList.DigitalList.push({ "Bsdid": parseInt($(this).data("id")) });
        //});

        functList.Bluid = parseInt(me.visual.find('#ddl-bluid').val());


        //The logic defines how the conditions get logical combined
        //The logic gets stored as stack array
        functList.Logic = [];

        //the first condition always exist
        functList.Logic.push("0");

        //now we get all additional conditions
        me.visual.find(".condition").each(function () {
            if (cond>0) {
               
                functList.Logic.push(cond + "");
                functList.Logic.push($(this).find("#ddl-logic").val());
            }
            cond ++;
        });

        return functList;
     
    } catch (ex) { me.writeError('getFunctList', ex); return "{}"; }
}; 



//AlarmRules2.prototype.askTask = function (obj) {
//    var me = this;
//    var txt = "";
//    try {
//        var task = parseInt(obj.data("task"));
//        switch (task) {
//            case 2:
//                txt = me.resources.shouldSendTestalarm; break;
//            case 3:
//                txt = me.resources.shouldResetAlarm;break;
//        }

//        me.openAskDialog(txt + "<br/><br/>" + me.resources.pleaseValidateIfConfigIsClean,
//            { at: 'center center-30%', of: window },
//            function () { me.sendTask(obj) },
//            function () { return false });
      
//    } catch (ex) { me.writeError('askTask', ex);  }
//};  


//AlarmRules2.prototype.sendTask = function (obj) {
//    /// <summary>
//    /// This function sends a test or reset alarm task to the unit. 
//    /// </summary>
//    var me = this;
//    try {
//        var task = parseInt(obj.data("task"));
//        var param = { "type": task };
//        param.AlarmSignalParam = me.getParameter();

//        if (param.AlarmSignalParam === null) { return false };

//        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', me.deviceType, me.langid, JSON.stringify(param),
//            function (result) {
//                if (result == null) { alert(me.resources.err_saveData); return false; }
//                if (result === false) {
//                    alert(me.resources.err_saveData);
//                } else {
//                    me.visual.find('#divBtnSave').removeClass("active");
//                    obj.removeClass("active");
//                }
//                return false;
//            });
//        return true;
//    } catch (ex) { me.writeError('sendTasks', ex); return false; }
//};  


AlarmRules2.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('#div-logic').hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};

vcTemplate.prototype.writeError = function (source, ex) {
    var me = this;
    try {
        console.info(ex);
        me.error = true;
        me.showMessage(me.resources.err_code, true);
        writeError(me.source + ".JS." + source, ex);
        return false;
    } catch (ex) {
        me.error = true;
        writeError(me.source + '.JS.writeError', ex);
        return false;
    }
};


